import {
  INPUT_CC_NUMBER,
  INPUT_CC_EXPIRATION_MONTH,
  INPUT_CC_EXPIRATION_YEAR,
  INPUT_CC_SECURITY_CODE,
  INPUT_FIRST_NAME,
  INPUT_LAST_NAME,
  INPUT_EMAIL_ADDRESS,
  INPUT_PHONE_NUMBER,
  INPUT_BILLING_ADDRESS,
  INPUT_BILLING_COUNTRY,
  INPUT_BILLING_ZIP,
  INPUT_BILLING_CITY,
  INPUT_BILLING_STATE,
  CHECKOUT_STATUS_WAITING,
  CHECKOUT_STATUS_PROCESSING,
  CHECKOUT_STATUS_SUCCESS,
  CHECKOUT_STATUS_FAILED,
  TERMS_FIELD,
  DICTIONARY,
} from '../constants/checkout'
import {
  FOCUS_INPUT,
  UPDATE_INPUT,
  DELETE_INPUT,
  ERROR_INPUT,
  CHECKOUT_REQUEST,
  CHECKOUT_FAILURE,
  PAY_NOW_REQUEST,
  PAY_NOW_SUCCESS,
  PAY_NOW_FAILURE,
  SET_STATUS,
  FOCUS_KEYBOARD,
  ACCOUNT_DETAILS_REQUEST,
  ACCOUNT_DETAILS_SUCCESS,
  ACCOUNT_DETAILS_FAILURE,
  SET_VALUE_INPUT,
} from '../actions/checkout'
import { FETCH_CART_REQUEST } from '../actions/cart'
import { COUNTRY_IDS, COUNTRIES_BY_ID, COUNTRY_CODES_BY_ID } from '../constants/countries'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  status: CHECKOUT_STATUS_WAITING,
  focusedInput: INPUT_CC_NUMBER,
  errors: {},
  failedMessage: '',
  isAccountDetailsReady: false,
  countries: COUNTRY_IDS,
  countriesById: COUNTRIES_BY_ID,
  countryCodesById: COUNTRY_CODES_BY_ID,
  termsField: false,
  dictionary: {},
}

INITIAL_STATE[INPUT_CC_NUMBER] = ''
INITIAL_STATE[INPUT_CC_EXPIRATION_MONTH] = ''
INITIAL_STATE[INPUT_CC_EXPIRATION_YEAR] = ''
INITIAL_STATE[INPUT_CC_SECURITY_CODE] = ''
INITIAL_STATE[INPUT_FIRST_NAME] = ''
INITIAL_STATE[INPUT_LAST_NAME] = ''
INITIAL_STATE[INPUT_EMAIL_ADDRESS] = ''
INITIAL_STATE[INPUT_PHONE_NUMBER] = ''
INITIAL_STATE[INPUT_BILLING_ADDRESS] = ''
INITIAL_STATE[INPUT_BILLING_COUNTRY] = -1
INITIAL_STATE[INPUT_BILLING_ZIP] = ''
INITIAL_STATE[INPUT_BILLING_CITY] = ''
INITIAL_STATE[INPUT_BILLING_STATE] = ''

INITIAL_STATE.errors[INPUT_CC_NUMBER] = ''
INITIAL_STATE.errors[INPUT_CC_EXPIRATION_MONTH] = ''
INITIAL_STATE.errors[INPUT_CC_EXPIRATION_YEAR] = ''
INITIAL_STATE.errors[INPUT_CC_SECURITY_CODE] = ''
INITIAL_STATE.errors[INPUT_FIRST_NAME] = ''
INITIAL_STATE.errors[INPUT_LAST_NAME] = ''
INITIAL_STATE.errors[INPUT_EMAIL_ADDRESS] = ''
INITIAL_STATE.errors[INPUT_PHONE_NUMBER] = ''
INITIAL_STATE.errors[INPUT_BILLING_ADDRESS] = ''
INITIAL_STATE.errors[INPUT_BILLING_COUNTRY] = ''
INITIAL_STATE.errors[INPUT_BILLING_ZIP] = ''
INITIAL_STATE.errors[INPUT_BILLING_CITY] = ''
INITIAL_STATE.errors[INPUT_BILLING_STATE] = ''

const checkoutReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CART_REQUEST:
      return {
        ...state,
        status: CHECKOUT_STATUS_WAITING,
      }
    case FOCUS_INPUT:
      return {
        ...state,
        focusedInput: action.payload.focusedInput,
      }
    case UPDATE_INPUT:
      if (
        state.focusedInput === INPUT_CC_NUMBER ||
        state.focusedInput === INPUT_CC_EXPIRATION_MONTH ||
        state.focusedInput === INPUT_CC_EXPIRATION_YEAR ||
        state.focusedInput === INPUT_CC_SECURITY_CODE
      ) {
        if (
          ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(
            action.payload.newKey
          ) === -1
        ) {
          return state
        }
      }
      let newValue
      if (
        state.focusedInput === INPUT_EMAIL_ADDRESS &&
        action.payload.newKey.indexOf('@') !== -1
      ) {
        const atPos = state[state.focusedInput].indexOf('@')
        if (atPos !== -1) {
          newValue = state[state.focusedInput].substr(0, atPos) + action.payload.newKey
        } else {
          newValue = action.payload.newKey
        }
      } else {
        newValue = action.payload.newKey
      }
      return {
        ...state,
        [state.focusedInput]: newValue,
        errors: {
          ...state.errors,
          [state.focusedInput]: '',
        },
      }
    case DELETE_INPUT:
      return {
        ...state,
        [state.focusedInput]: state[state.focusedInput].substr(
          0,
          state[state.focusedInput].length - 1
        ),
        errors: {
          ...state.errors,
          [state.focusedInput]: '',
        },
      }
    case ERROR_INPUT:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.input]: action.payload.error,
        },
      }
    case PAY_NOW_SUCCESS:
      return {
        ...state,
        status: CHECKOUT_STATUS_SUCCESS,
        [INPUT_CC_NUMBER]: '',
        [INPUT_CC_EXPIRATION_MONTH]: 1,
        [INPUT_CC_EXPIRATION_YEAR]: new Date().getFullYear(),
        [INPUT_CC_SECURITY_CODE]: '',
        focusedInput: INPUT_CC_NUMBER,
        keyboardFocused: true,
        focusedRow: 0,
        focusedCol: 0,
      }
    case CHECKOUT_FAILURE:
    case PAY_NOW_FAILURE:
      return {
        ...state,
        status: CHECKOUT_STATUS_FAILED,
        failedMessage: action.payload.message,
        focusedInput: INPUT_CC_NUMBER,
        keyboardFocused: true,
        focusedRow: 0,
        focusedCol: 0,
      }
    case SET_STATUS:
      return {
        ...state,
        status: action.payload.status,
      }
    case FOCUS_KEYBOARD:
      return {
        ...state,
        keyboardFocused: action.payload.focus,
      }
    case CHECKOUT_REQUEST:
    case PAY_NOW_REQUEST:
      return {
        ...state,
        status: CHECKOUT_STATUS_PROCESSING,
      }
    case ACCOUNT_DETAILS_REQUEST:
      return {
        ...state,
        isAccountDetailsReady: false,
      }
    case ACCOUNT_DETAILS_SUCCESS:
      const newFirstName =
        state[INPUT_FIRST_NAME] !== ''
          ? state[INPUT_FIRST_NAME]
          : action.payload.accountDetails.firstname
      const newLastName =
        state[INPUT_LAST_NAME] !== ''
          ? state[INPUT_LAST_NAME]
          : action.payload.accountDetails.lastname
      const newEmailAddress =
        state[INPUT_EMAIL_ADDRESS] !== ''
          ? state[INPUT_EMAIL_ADDRESS]
          : action.payload.accountDetails.email
      const newPhoneNumber =
        state[INPUT_PHONE_NUMBER] !== ''
          ? state[INPUT_PHONE_NUMBER]
          : action.payload.accountDetails.phone
      const newBillingAddress =
        state[INPUT_BILLING_ADDRESS] !== ''
          ? state[INPUT_BILLING_ADDRESS]
          : action.payload.accountDetails.address
      const newBillingCountry =
        state[INPUT_BILLING_COUNTRY] !== -1
          ? state[INPUT_BILLING_COUNTRY]
          : parseInt(action.payload.accountDetails.country_id, 10)
      const newBillingZip =
        state[INPUT_BILLING_ZIP] !== ''
          ? state[INPUT_BILLING_ZIP]
          : action.payload.accountDetails.zip
      const newBillingCity =
        state[INPUT_BILLING_CITY] !== ''
          ? state[INPUT_BILLING_CITY]
          : action.payload.accountDetails.city
      const newBillingState =
        state[INPUT_BILLING_STATE] !== ''
          ? state[INPUT_BILLING_STATE]
          : action.payload.accountDetails.state

      return {
        ...state,
        isAccountDetailsReady: true,
        [INPUT_FIRST_NAME]: newFirstName,
        [INPUT_LAST_NAME]: newLastName,
        [INPUT_EMAIL_ADDRESS]: newEmailAddress,
        [INPUT_PHONE_NUMBER]: newPhoneNumber,
        [INPUT_BILLING_ADDRESS]: newBillingAddress,
        [INPUT_BILLING_COUNTRY]: newBillingCountry,
        [INPUT_BILLING_ZIP]: newBillingZip,
        [INPUT_BILLING_CITY]: newBillingCity,
        [INPUT_BILLING_STATE]: newBillingState,
      }
    case ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        isAccountDetailsReady: true,
      }
    case SET_VALUE_INPUT:
      return {
        ...state,
        [action.payload.input]: action.payload.value,
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE,
      }
    case TERMS_FIELD:
      return {
        ...state,
        termsField: action.terms,
      }
    case DICTIONARY:
      return {
        ...state,
        dictionary: action.dictionary,
      }

    default:
      return state
  }
}

export default checkoutReducer
